import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_21vc5x7n3h: FaireBrandEntity = {
  token: "b_21vc5x7n3h",
  type: "brand",
  name: "Mira Blackman",
  avatarUrl:
    "https://cdn.faire.com/fastly/306074e77e1248e18a60d6b3c428b94696a43c7aaf364d31af45d2c3b28ee3e8.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/ccc6ba922c26369b788df3b42d7b8e9d4e7cfc36c170aee2e3155eecd3ebc036.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/306074e77e1248e18a60d6b3c428b94696a43c7aaf364d31af45d2c3b28ee3e8.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ccc6ba922c26369b788df3b42d7b8e9d4e7cfc36c170aee2e3155eecd3ebc036.jpeg",
  location: "Oakland, CA, USA",
  minimumOrderDollars: 200,
  rating: 5,
  reviewCount: 31,
  isInsider: true,
  description:
    "I began dyeing as a way to personalize clothing for my babies. Eventually my friends and family wanted hand-dyed pieces too so I started making more to sell. \nNow I'm happy to be working with local mills & manufacturers to produce high-quality organic fabrics & silhouettes that we hand dye ourselves. Every element from the temperature that day, to the way the wind is blowing, contributes to the way these pieces come out. It's a truly magical and collaborative process that makes each piece one of a kind.\nWe also introduced our Essentials Collection this year. The same easy-to-wear silhouettes but in solid colors for our friends with a more minimal aesthetic. \n",
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:28:12.639Z",
    importedBy: "entity-db-cli",
  },
};
